import React from "react";
import leftlogo from "../images/logo_left.png";
import rightlogo from "../images/logo_right.png";
import profilephoto from "../images/profilephoto.jpg";
import "./main2.css";

const Main2 = ({ solmate_data, index }) => {
  // Helper function to safely access nested properties
  const getFieldValue = (customIndex, fieldIndex, fallback = "--") => {
    if (!solmate_data.contact_customs || 
        !solmate_data.contact_customs[customIndex] || 
        !solmate_data.contact_customs[customIndex].Fields || 
        !solmate_data.contact_customs[customIndex].Fields[fieldIndex]) {
      return fallback;
    }
    return solmate_data.contact_customs[customIndex].Fields[fieldIndex].PreFilled || fallback;
  };

  const getFieldName = (customIndex, fieldIndex, fallback = "") => {
    if (!solmate_data.contact_customs || 
        !solmate_data.contact_customs[customIndex] || 
        !solmate_data.contact_customs[customIndex].Fields || 
        !solmate_data.contact_customs[customIndex].Fields[fieldIndex]) {
      return fallback;
    }
    return solmate_data.contact_customs[customIndex].Fields[fieldIndex].Name || fallback;
  };

  return (
    <>
      <div
        style={{
          fontFamily: "Roboto, sans-serif",
          border: "5px solid #c53c32",
          width: "447px",
          height: "631px",
          marginBottom: index > 2 ? "0.47px" : "0px",
        }}
      >
        <div className="top-portion">
          <div>
            <img
              src={leftlogo}
              style={{ width: "50px", height: "50px" }}
              alt="left_logo"
            />
          </div>
          <div>
            <h4
              className="red-color"
              style={{ fontSize: "16px", marginTop: "18px" }}
            >
              SOULMATE &nbsp;CONNECT
            </h4>
          </div>
          <div>
            <img
              src={rightlogo}
              style={{ width: "50px", height: "50px" }}
              alt="right_logo"
            />
          </div>
        </div>

        {/* middle portion  */}
        <div className="middle-portion">
          <div className="gray-background">
            <div className="middle-left">
              <div>
                <img
                  className="left-img-middle"
                  src={solmate_data.contact_photo_path || profilephoto}
                  alt="Candidate Photo"
                />
              </div>
              <div className="margin-left-common">
                <h6
                  className="red-color common-header"
                  style={{ marginTop: "0.2rem" }}
                >
                  EDUCATION &nbsp;DETAILS
                </h6>
                <p className="common-para">
                  Education : {solmate_data.education || "--"} 
                </p>
                <p className="common-para">
                  Qualifications (Skills) : {solmate_data.qualifications || "--"}
                </p>
              </div>
              <hr className="seperator" />
              <div className="margin-left-common">
                <h6 className="red-color common-header">
                  CANDIDATE &nbsp;OCCUPATION
                </h6>
                <p className="common-para">
                  Occupation : {solmate_data.occupation || "--"}
                </p>
                <p className="common-para">
                  {getFieldName(2, 50, "Occupation Details")} : {getFieldValue(2, 50)}
                </p>
              </div>
              <hr className="seperator" />
              <div className="margin-left-common">
                <h6 className="red-color common-header">
                  PHYSICAL &nbsp;ATTRIBUTES
                </h6>
                <p className="common-para">
                  {getFieldName(5, 30, "Height")} : {getFieldValue(5, 30)}
                </p>
                <p className="common-para">
                  {getFieldName(5, 31, "Weight")} : {getFieldValue(5, 31)}
                </p>
                <p className="common-para">
                  {getFieldName(5, 32, "Complexion")} : {getFieldValue(5, 32)}
                </p>
              </div>
              <hr className="seperator" />
              <div className="margin-left-common">
                <h6 className="red-color common-header">
                  SOCIAL &nbsp;ATTRIBUTES
                </h6>
                <p className="common-para">
                  {getFieldName(3, 49, "Diet")} : {getFieldValue(3, 49)}
                </p>
                <p className="common-para">
                  Gothra : {solmate_data.gotra_name || "--"}
                </p>
              </div>
              <hr className="seperator" />
              <div className="margin-left-common">
                <h6 className="red-color common-header">{getFieldName(1, 51, "Hobbies")}</h6>
                <p className="common-para">
                  {getFieldValue(1, 51) !== "--" ? (
                    <>
                      {getFieldValue(1, 51).split(",")
                        .slice(0, 4)
                        .join(", ")}
                      {getFieldValue(1, 51).split(",").length > 4 && (
                        <>
                          <br />
                          {getFieldValue(1, 51).split(",")
                            .slice(4)
                            .join(", ")}
                        </>
                      )}
                    </>
                  ) : (
                    "--"
                  )}
                </p>
              </div>
            </div>
          </div>
          <div>
            <div className="bg-red f-white">
              <div className="margin-left-common">
                <h6
                  className="common-header right-info-header"
                  style={{ fontWeight: "bold" }}
                >
                  {solmate_data.name || "--"}
                </h6>
                <div>
                  <div className="right-info">
                    <label className="common-para">Birth Date & Time</label>
                    <p className="common-para text-start">
                      : {solmate_data.dob || "--"}
                    </p>
                  </div>
                  <div className="right-info">
                    <label className="common-para">{getFieldName(4, 52, "Birth Place")}</label>
                    <p className="common-para text-start">
                      : {getFieldValue(4, 52)}
                    </p>
                  </div>
                  <div className="right-info">
                    <label className="common-para">Marital Status:</label>
                    <p className="common-para text-start">
                      : {solmate_data.marital_status || "--"}
                    </p>
                  </div>
                  <div className="right-info">
                    <label className="common-para">Age</label>
                    <p className="common-para text-start">
                      : {solmate_data.age || "--"}
                    </p>
                  </div>
                  <div className="right-info">
                    <label className="common-para">Mobile</label>
                    <p className="common-para text-start">
                      {solmate_data.mobile ? (
                        <>
                          {solmate_data.isd ? (
                            <>
                              :{" "}
                              {solmate_data.isd.startsWith("+")
                                ? solmate_data.isd
                                : `+${solmate_data.isd}`}{" "}
                              {solmate_data.mobile}
                            </>
                          ) : (
                            <>: {solmate_data.mobile}</>
                          )}
                        </>
                      ) : (
                        <>: --</>
                      )}
                    </p>
                  </div>
                  <div className="right-info">
                    <label className="common-para">WhatsApp</label>
                    <p className="common-para text-start">
                      {solmate_data.whatsapp ? (
                        <>
                          {solmate_data.isd ? (
                            <>
                              :{" "}
                              {solmate_data.isd.startsWith("+")
                                ? solmate_data.isd
                                : `+${solmate_data.isd}`}{" "}
                              {solmate_data.whatsapp}
                            </>
                          ) : (
                            <>: {solmate_data.whatsapp}</>
                          )}
                        </>
                      ) : (
                        <>: --</>
                      )}
                    </p>
                  </div>
                  <div className="right-info">
                    <label className="common-para">Email</label>
                    <p className="common-para text-start">
                      : {solmate_data.email || "--"}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="margin-left-common">
              <h6
                className="red-color common-header"
                style={{ marginTop: "0.2rem" }}
              >
                CANDIDATE &nbsp;ADDRESS
              </h6>
              <p className="common-para">{solmate_data.contact_address || "--"}</p>
            </div>
            <hr className="seperator" />
            <div style={{ marginLeft: "10px" }}>
              <h6
                className="red-color common-header"
                style={{ marginTop: "0.2rem" }}
              >
                FAMILY &nbsp;DETAILS
              </h6>
              <div className="right-info">
                <label className="common-para">Father Name</label>
                <p className="common-para text-start">
                  : {getFieldValue(4, 34, "")} {getFieldValue(4, 35, "")}
                </p>
              </div>
              <div className="right-info">
                <label className="common-para">{getFieldName(4, "", "Father Occupation")}</label>
                <p className="common-para text-start">
                  : {getFieldValue(4, 36)}
                </p>
              </div>
              <div className="right-info" style={{ paddingBottom: "8px" }}>
                <label className="common-para">{getFieldName(4, 37, "Father Details")}</label>
                <p className="common-para text-start">
                  : {getFieldValue(4, 37)}
                </p>
              </div>
              <div className="right-info">
                <label className="common-para">Mother Name</label>
                <p className="common-para text-start">
                  : {getFieldValue(4, 38, "")} {getFieldValue(4, 39, "")} {getFieldValue(4, 40, "")}
                </p>
              </div>
              <div className="right-info">
                <label className="common-para">{getFieldName(4, "", "Mother Occupation")}</label>
                <p className="common-para text-start">
                  : {getFieldValue(4, 41)}
                </p>
              </div>
              <div className="right-info"  style={{ paddingBottom: "8px" }}>
                <label className="common-para">{getFieldName(4, 42, "Mother's Mobile Number")}</label>
                <p className="common-para text-start">
                  : {getFieldValue(4, 42)}
                </p>
              </div>
              <div className="right-info" style={{ paddingBottom: "8px" }}>
                <label className="common-para">{getFieldName(4, 43, "Parent's Address")}</label>
                <p className="common-para text-start">
                  : {getFieldValue(4, 43)}
                </p>
              </div>
              {/* <div className="right-info" style={{ paddingBottom: "8px" }}>
                <label className="common-para">{getFieldName(4, 35, "Family Occupation")}</label>
                <p className="common-para text-start">
                  : {getFieldValue(4, 35)}
                </p>
              </div> */}
              <div className="right-info">
                <label className="common-para">{getFieldName(4, 44, "Annual Family Income")}</label>
                <p className="common-para text-start">
                  : {getFieldValue(4, 44)}
                </p>
              </div>
              <div className="right-info">
                <label className="common-para">{getFieldName(4, 45, "Unmarried Brothers")}</label>
                <p className="common-para text-start">
                  : {getFieldValue(4, 45)}
                </p>
              </div>
              <div className="right-info">
                <label className="common-para">{getFieldName(4, 46, "Unmarried Sisters")}</label>
                <p className="common-para text-start">
                  : {getFieldValue(4, 46)}
                </p>
              </div>
              <div className="right-info">
                <label className="common-para">{getFieldName(4, 47, "Married Brothers")}</label>
                <p className="common-para text-start">
                  : {getFieldValue(4, 47)}
                </p>
              </div>
              <div className="right-info">
                <label className="common-para">{getFieldName(4, 48, "Married Sister")}</label>
                <p className="common-para text-start">
                  : {getFieldValue(4, 48)}
                </p>
              </div>
            </div>
            <hr className="seperator" />

            <div className="margin-left-common">
              <h6
                className="red-color common-header"
                style={{ marginTop: "0.2rem" }}
              >
                {getFieldName(3, 53, "Additional Information")}
              </h6>
              <p className="common-para">
                {getFieldValue(3, 53)}
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Main2;